import { CollegeDetailService } from './../../services/college-detail.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-degrees-major',
  templateUrl: './degrees-major.component.html',
  styleUrls: ['./degrees-major.component.scss']
})
export class DegreesMajorComponent implements OnChanges {
  @Input() collegeData: any;
  majorCareersListJson = [];
  searchFilter = '';
  degreeMajorLoader = false;
  isTwoYear: boolean;

  constructor(
    private notificationService: NotificationService,
    private _collegeDetailService: CollegeDetailService
  ) { }

  ngOnChanges() {
    this.degreeMajorLoader = true;
    if (this.collegeData) {
      const inputJson = {
        collegeId: this.collegeData
      };

      this._collegeDetailService.getMajorsCareers(inputJson)
        .subscribe(
        (data: any) => {
          this.degreeMajorLoader = false;
          this.isTwoYear = data.isTwoYear;
          this.majorCareersListJson = data.items;
        },
        () => {
          this.degreeMajorLoader = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
    }
  }
}
